import { useGummiwormContext } from "@/context/GummiwormContext";

/** Returns "Sugar Rush" after the reveal, "Gummiworm" before. */
export function useBrandName(): string {
  const { tradingEnabled } = useGummiwormContext();
  return tradingEnabled ? "Sugar Rush" : "Gummiworm";
}
